import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import BasicData from './BasicData';
import Description from './Description';
import Assignation from './Assignation';
import Affectation from './Affectation';
import { useForm } from 'react-hook-form';
import { TicketUpdateFormModel } from '../../models/ticket.model';
import useOnUpdate from '../../hooks/useOnUpdate';
import { Alert, Grid } from '@mui/material';
import Attachment from './Attachment';
import {
  getAreasByCompany, getCompanies, getPersonsByProject,
  getTicketPriorities, getTicketStatus
} from '../../services/autocomplete.service';

import FormSection, { FormElement } from '../common/FormSection';
import MainContainer from '../common/MainContainer';
import { useNotification } from '../../context/NotificationContext';
import CustomFields from './CustomFields';
import Notifications from './Notification';


interface HandleFormProps {
  action?: string
  handleChange: (p: any) => void
  handleSelection: (...args: any[]) => void
  onSubmit: (p: any) => void
  ticketUpdateForm: any
  selectedProject: string
  handleCustomFieldChange?: (...args: any[]) => void
}

export default function HandleForm({ action, handleChange, handleSelection,
  handleCustomFieldChange, onSubmit, ticketUpdateForm, selectedProject }: HandleFormProps) {

  const { showNotification } = useNotification();
  const { handleSubmit } = useForm<TicketUpdateFormModel>()

  const [statusList, setStatusList] = useState([]);
  const [prioritiesList, setPrioritiesList] = useState([]);
  const [companiesList, setCompaniesList] = useState([]);
  const [areasList, setAreasList] = useState([]);
  const [personsList, setPersonsList] = useState([]);
  const [resetArea, setResetArea] = useState(false)

  const requiredFields = [
    'company',
    'area',
    'priority',
    'status_n',
  ]

  const initComponent = () => {
    if (action === 'create') {
      Promise.all([
        getCompanies(selectedProject),
        getTicketStatus(selectedProject),
        getTicketPriorities(selectedProject),
        getPersonsByProject(selectedProject)
      ]).then(function (result) {
        setCompaniesList(result[0])
        setStatusList(result[1])
        setPrioritiesList(result[2])
        setPersonsList(result[3])
      }).catch((error) => {
        showNotification(error.response.data, 'error')
      })
    }
  }

  useEffect(initComponent, []);

  const getAreasCompany = () => {
    if (action === "create") {
      if (resetArea) {
        handleSelection('area', '')
      }
      setResetArea(true)
      if (ticketUpdateForm.company) {
        Promise.all([
          getAreasByCompany(ticketUpdateForm.company.id, selectedProject),
        ]).then(function (result) {
          setAreasList(result[0])

        }).catch((error) => {
          showNotification(error.response.data, 'error')
        })
      }
    }
  };

  useOnUpdate(getAreasCompany, [ticketUpdateForm.company.id]);


  const formValidator = () => {
    return requiredFields.some((key) => !ticketUpdateForm[key] || Object.keys(ticketUpdateForm[key]).length === 0)
  }

  return (
    <React.Fragment>
      <MainContainer>
        <FormSection>
          <div className='ticket-form-halfwidth'>
            <FormElement>
              <Assignation
                action={action}
                handleSelection={handleSelection}
                ticketUpdateForm={ticketUpdateForm}
                companiesList={companiesList}
                areasList={areasList}
                personsList={personsList}
              />
            </FormElement>
          </div>

          <div className='ticket-form-halfwidth'>

          <FormElement>
            <BasicData
              action={action}
              handleChange={handleChange}
              handleSelection={handleSelection}
              ticketUpdateForm={ticketUpdateForm}
              statusList={statusList}
              prioritiesList={prioritiesList}
            />
          </FormElement>
          </div>

            <FormElement>
              <Affectation
                handleSelection={handleSelection}
                ticketUpdateForm={ticketUpdateForm}
              />
            </FormElement>

          <FormElement>
            <Description
              action={action}
              handleChange={handleChange}
              ticketUpdateForm={ticketUpdateForm}
            />
          </FormElement>

          <FormElement>
            <CustomFields
              action={action}
              handleChange={handleCustomFieldChange}
              ticketUpdateForm={ticketUpdateForm}
            />
          </FormElement>

          <FormElement>
            <Notifications
              handleSelection={handleSelection}
              notificationProfilesList={[]}
              ticketUpdateForm={ticketUpdateForm}
            />
          </FormElement>   

          <FormElement>
            <Attachment
              action={action}
              handleSelection={handleSelection}
              ticketUpdateForm={ticketUpdateForm}
            />
          </FormElement>

          <Grid container marginTop={'4vh'} rowSpacing={'2vh'} columnSpacing={'2vw'}>
            <Grid item xs={12} md={4}>
              <Typography fontFamily="Poppins" variant="caption" gutterBottom>
                (*) Campos requeridos
              </Typography>
            </Grid>

            <Grid item xs={12} md={4}>
              <Alert
                sx={{ display: formValidator() ? 'flex' : 'none' }}
                color="error"
                severity="info">
                Hay campos requeridos sin completar
              </Alert>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  style={{ display: action === 'view' ? 'none' : '', fontFamily: 'Poppins' }}
                  variant="contained"
                  color="success"
                  onClick={handleSubmit(onSubmit)}
                  disabled={formValidator()}
                >
                  Confirmar
                </Button>
              </Box>
            </Grid>

          </Grid>
        </FormSection>
      </MainContainer>
    </React.Fragment>
  );
}
